import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Sets the CSS `--delay` custom property for staggered entrance animations. */
export const animDelay = (ms: number) =>
  ({ "--delay": `${ms}ms` }) as React.CSSProperties;
